// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v5ccdBHCxXKTcW {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  background-color: #F4F5F7;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": "v5ccdBHCxXKTcW"
};
export default ___CSS_LOADER_EXPORT___;
